<template>
    <body>
    <!-- <div>Free clients counter: {{this.$store.getters.getFreeClientsNumber}}</div> -->
    <div class="stripe-container">
        <div class="col-25">
            <div >
                Payment by
                <a href="https://stripe.com/en-ro"  target="_blank">
                    <i class="fa fa-cc-stripe"></i>
                </a>
            </div>
            <div class="icon-container">
                <img src="../assets/stripe-badge-grey.png" width="40%" height="40%">
            </div>
        </div>
        <div class="col-75">
            <form action="/charge" method="post"  @submit.prevent="submitBuyerInfo"  id="payment-form">
                <label for="entity" class="required">Name</label> &nbsp;
                <input id="entity" name="entity" type="business" placeholder="Company Name" v-model="entity_name" @keyup="checkEntity" required>
                <label for="address" class="required">Address</label>
                <input id="address" name="entity" type="text" placeholder="Billing Address" v-model="entity_address"  @keyup="checkEntity" required>
                <div class="row">
                    <div class="col-25">
                        <label for="vatid" class="required">Vat.Id</label>
                        <input id="vatid" name="vatid" type="business" placeholder="RO12345678" v-model="entity_vatid" @keyup="checkEntity" required/>
                    </div>
                    <div class="col-25">
                        <label for="regno" class="required">Reg.No</label>
                        <input id="regno" name="regno" type="business" placeholder="J22/842/2024" v-model="entity_regno" @keyup="checkEntity" required/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-75">
                        <label for="emailconfirm" class="required">E-mail</label> &nbsp;
                        <input id="emailconfirm" name="email" type="email" placeholder="name@server.domain" v-model="entity_email" @keyup="checkEntity" required>
                        <label for="months"></label>&nbsp;&nbsp;
                        <input type="number" id="months"  min="1" max="12" v-model="nmonths"  @change="checkEntity" @keyup="checkEntity">
                        <span style="font-size: 12px;margin-left: 5px;margin-right: 5px;font-weight: bold">month</span>
                        <i class="fa fa-calendar-check-o" aria-hidden="true"></i>&nbsp;
                        <span class="valability">
                            {{valability}}
                        </span>
                    </div>
                </div>
                <label for="card-element">
                </label>
                <div>
                    <span style="font-size: 11px;float:left">* Invoice Required fields </span>
                </div>
                <br>
                <div class="col-50">
                    <div id="card-element">
                        <!-- A Stripe Element will be inserted here. -->
                    </div>
                    <!-- Used to display form errors. -->
                    <div id="card-errors" role="alert"></div>
                    <div class="bankmsg">
                        By providing your Card Number and confirming this payment, you are
                        authorizing <span style="font-weight: bold">ulip ou</span> and <span style="font-weight: bold">Stripe</span>, our payment service
                        provider, to send instructions to your bank to debit your account.
                    </div>
                </div>
                <br>
                <hr>
                <div class="col-50">
                    <button :disabled="disablePayButton" class="btn" id="paybtn">
                        <!--
                        <span hidden id="spin">
                            <i class="fa fa-spinner fa-spin" ></i>
                        </span> -->
                        Pay
                        <span>
                            {{price}}
                        </span>&nbsp;
                        <i class="fa fa-eur" aria-hidden="true"></i>
                    </button> &nbsp; &nbsp;
                    <button  class="btnredeem" @click="redeempayment()">
                        1 month Free Trial
                    </button> <!-- v-show="hideRedeem" -->
                    &nbsp;&nbsp;
                    <button class="btncancel" @click="cancelpayment()">Cancel</button>
                </div>
            </form>
        </div>
    </div>
    <div style="font-size: 12px;padding-top: 10px">
        <span style="color: yellow"><i class="fa fa-shield" aria-hidden="true" ></i> Privacy Policy</span> Input Data are not stored on the sAPPo Server
    </div>
    </body>
</template>
<script>
    import {getBaseURL} from '../url_endpoints.js'
    import {ulip_post} from '../https_requests.js'
    import {salesToAnalytics} from 'salesstats'
    export default {
        name: 'Payment',
        data() {
            return {
                entity_email: null,
                entity_name:null,
                entity_address:null,
                entity_vatid:null,
                entity_regno:null,
                stripe: '',
                elements: '',
                card: null,
                entityFlag: false,
                stripeAPI:null,
                nmonths:1,
                baseURL:null,
                stripeClientTokenId:null,
                mailServerMsg:null,
                authAWE: {
                  username:'aff_programs',
                  password:'mee_and_you_is_',
                }
            }
        },
        mounted() {
            this.baseURL = getBaseURL()
            this.startPaymentBusinessClient()
        },
        computed: {
            hideRedeem() {
                return !this.$store.getters.getExtendActive
            },
            disablePayButton() {
                return !this.entityFlag
            },
            price() {
                return this.$store.getters.getPricePerMonth * this.nmonths
            },
            valability() {
                let now = new Date()
                /*
                let safaribw = false
                if(this.$store.getters.getExtendActive) {
                    const stime = this.$store.getters.getCurrentBusiness.subscription_time
                    const num_months = this.$store.getters.getCurrentBusiness.subscription_months
                    now = new Date(stime)
                    if(isNaN(now)) {
                        // SAFARI case
                        safaribw = true
                        const darr = stime.split('-')
                        now = new Date(darr[0],darr[1],darr[2])
                    }
                    now.setMonth(now.getMonth() + num_months);
                }*/
                now.setMonth((now.getMonth()+1) + this.nmonths);
                //return safaribw ? now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate() : now.getFullYear() + '-' + (now.getMonth()+1) + '-' + now.getDate()
                return now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate()
            }
        },
        methods: {
            testAnalytics(value,currency) {
              //console.log('Currency: '+currency +' Value: '+value)
              const AWE_PLATFORM_URL =  'https://awe-server-279e3d1a5920.herokuapp.com'
              const AWE_LOCAL = 'http://localhost:3006'
              const serverURL = (process.env.NODE_ENV === 'production') ? AWE_PLATFORM_URL : AWE_LOCAL
              const endPoint = '/wizard/sale'
              salesToAnalytics({sale_value:value,currency:currency},serverURL,endPoint,this.authAWE,true)
            },
            isSuspendedAccount() {
                return !this.$store.getters.getSuspendedAccount ? false : this.$store.getters.getSuspendedAccount
            },
            startPaymentBusinessClient() {
                // init email if localStorage
                this.entity_email = !localStorage.getItem('business_email') ? null : localStorage.getItem('business_email')
                // select stripe API
                this.stripeAPI = (process.env.NODE_ENV === 'development') ? process.env.VUE_APP_STRIPE_TEST_API :process.env.VUE_APP_STRIPE_LIVE_API
                this.configClientStripe()
            },
            checkEntity(){
                if(!this.entity_address || !this.entity_name ||
                    !this.entity_email || !this.entity_vatid ||
                    !this.entity_regno || (this.nmonths < 1)) {
                    // set flag
                    this.entityFlag = false
                } else {
                    this.entityFlag = true
                }
            },
            getInvoiceObject() {
                let obj = {
                    address: this.entity_address,
                    name: this.entity_name,
                    email: this.entity_email
                }
                return obj
            },
            submitBuyerInfo(){
                this.stripe.createToken(this.card).then(result => {
                    // start payment - disable pay button
                    this.entityFlag = false
                    //console.log('Stripe payment client token id:', result.token.id)
                    this.stripeClientTokenId = result.token.id
                    // send data to backend to get secret token of transaction
                    // send also email and payment value - tokenValue
                    const tkV = this.$store.getters.getPricePerMonth * this.nmonths
                    fetch(this.baseURL + '/secret?tokenValue=' + tkV + '&&email=' + this.entity_email,{
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        }).then( rsp => {
                            //console.log('Request secret from STRIPE server...')
                            if(rsp.ok) {
                                return rsp.json()
                            } else {
                                return rsp.json().then( body => {
                                // transfer error generated in backend to frontend
                                throw Error(body.error)
                                })
                            }
                        }).then( response => {
                            //console.log(response)
                            let secretrsp = Object.assign({}, response)
                            let secret = secretrsp['client_secret']
                            //console.log('Secret received...')
                            // proceed to payment
                            // get invoice data
                            let invoiceObject = this.getInvoiceObject()
                            this.stripe.confirmCardPayment(secret, {
                                payment_method: {
                                    card: this.card,
                                    billing_details: {
                                        address: {
                                            //city: 'tm',
                                            //state: 'romania',
                                            line1: invoiceObject.address,
                                            //country: "RO",
                                            //postal_code: 3333444
                                            },
                                        name: invoiceObject.name,
                                        email: invoiceObject.email
                                    },
                                }
                            }).then(payrsp => {
                                //console.log('Stripe Card Payment response...')
                                if(payrsp.paymentIntent.status === "succeeded") {
                                     // send stats to AWE platform
                                     this.testAnalytics(tkV,'eur')
                                    // ********************************************* CHECK IF NEW CUSTOMER or RENEW one
                                    if(this.isSuspendedAccount()) {
                                        // get CURRENT BUSINESS
                                        const currentbusiness = this.$store.getters.getCurrentBusiness
                                        // compute extension time by number of months
                                        this.updateAccountSuspended(this.nmonths,currentbusiness.id)
                                    } else {
                                        // set data for NEW BUSINESS
                                        this.$store.commit('setBCandidateMonths',this.nmonths)
                                        let bcandidate = this.$store.getters.getBCandidate
                                        ulip_post(this.baseURL,'/business',bcandidate).then(rsp => {
                                            // store business object
                                            bcandidate.id = rsp['id']
                                            this.$store.commit('setCurrentBusiness',bcandidate)
                                            // set sign in to true
                                            this.$store.commit('setLoginState',true)
                                            // notify user
                                            /*
                                            alert('Stripe Payment succeeded.\n\nThank You for your order!'+
                                                '\n\nPrivate Key Access: '+bcandidate.code+
                                                '\nPlease save it in a safe place.' +
                                                '\nPlease check Your email')
                                            */
                                            const bc_len = bcandidate.code.length
                                            const amsg = prompt('New Business created.Thank You!\nPlease check Your E-mail\nYour signIN Access Key has '+bc_len+' chars\nPlease store it in a safe place',bcandidate.code)
                                            // send confirmation email
                                            if(!amsg) {
                                                //do nothing
                                            }
                                            // activate pay button
                                            this.entityFlag = true
                                            // send confirmation email
                                            let mail_data = {
                                                invoice: invoiceObject, // invoice data
                                                bcandidate: bcandidate, // business candidate info
                                            }
                                            ulip_post(this.baseURL,'/mail',mail_data).then(rsp => {
                                                this.mailServerMsg = rsp
                                                //console.log('response from email server :',rsp)
                                            }).catch(err => {
                                                alert(err.message+ '\nBackend Server could be down! Try again later..')
                                                this.$router.push('/business_signin')
                                            })
                                            // next step
                                            this.$store.commit('setLoginState',true)
                                            this.$router.push('/features')
                                        }).catch(err => {
                                            alert(err.message+ '\nBackend Server could be down! Try again later..')
                                            this.$router.push('/business_signin')
                                        })
                                    }
                                }
                            }).catch(payerr => {
                                this.entityFlag = true
                                //console.log('Stripe Card Payment error...',payerr.message)
                                alert('Stripe Card Payment set next error: \n' + payerr.message)

                            })
                        }).catch(err => {
                            this.entityFlag = true
                            alert('Backend/Stripe server error message: \n' + err)
                        })
                }).catch(err =>{
                    //console.log('Error when create Stripe Client token:', err.message)
                    alert(err.message+ '\n Init Stripe Payment process')
                })
            },
            configClientStripe(){
                this.stripe = window.Stripe(this.stripeAPI)
                this.elements = this.stripe.elements();
                this.card = this.elements.create('card');
                this.card.mount('#card-element');
                // Handle real-time validation errors from the card Element.;
                this.card.addEventListener('change', function(event) {
                    let displayError = document.getElementById('card-errors');
                    if (event.error) {
                        displayError.textContent = event.error.message;
                    } else {
                        displayError.textContent = '';
                    }
                });
            },
            cancelpayment() {
                if(this.isSuspendedAccount()) {
                    this.$router.push('/features')
                }else {
                    this.$router.push('/business_signin')
                }
            },
            // !!! HAVE TO IMPLEMENT REDEEM for CURRENT BUSINESS ( extend redem for a business)
            redeempayment() {
                let redeemcode = prompt('Get 1 month free access \n\n Please type the Trial Code...','code')
                if(!redeemcode) {
                    // cancel
                }else {
                    //check in BackEnd the redeem code resource
                    fetch(this.baseURL + '/redeems?code='+redeemcode, {
                        methods: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    }).then(rsp => {
                        return rsp.json()
                    }).then( data => {
                        if(data.length > 0 ) {
                            // redeem code found
                            // set valability
                            this.$store.commit('setBCandidateMonths',data[0].nmonths)
                            // store bcandidate
                            let bcandidate = this.$store.getters.getBCandidate
                            ulip_post(this.baseURL,'/business',bcandidate).then(rsp => {
                                // store business object
                                bcandidate.id = rsp['id']
                                this.$store.commit('setCurrentBusiness',bcandidate)
                                // set sign in to true
                                this.$store.commit('setLoginState',true)
                                // notify user
                                const bc_len = bcandidate.code.length
                                const amsg = prompt('New Business created.Thank You!\nPlease check Your E-mail\nYour signIN Access Key has '+bc_len+' chars\nPlease store it in a safe place',bcandidate.code)
                                // send confirmation email
                                if(!amsg) {
                                    //do nothing
                                }
                                let mail_data = {
                                    invoice: {email:localStorage.getItem('business_email')}, // invoice data
                                    bcandidate: bcandidate, // business candidate info
                                }
                                ulip_post(this.baseURL,'/mail',mail_data).then(rsp => {
                                    //console.log('response from email server :',rsp)
                                    this.mailServerMsg = rsp
                                }).catch(err => {
                                    alert(err.message+ '\nBackend Server could be down! Try again later..')
                                    this.$router.push('/business_signin')
                                })
                                // next step
                                this.$router.push('/features')
                            }).catch(err => {
                                alert(err.message+ '\nBackend Server could be down! Try again later..')
                                this.$router.push('/business_signin')
                            })
                        }else {
                            alert('Typed redeem code is invalid!')
                        }}).catch( err => {
                            alert(err.message+ '\nBackend Server could be down! Try again later..')
                    })
                }
            },
            updateAccountSuspended(number_of_months,id){
                // set also new subscription time
                const d = new Date()
                let subs_time = d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate() // add 1 = january
                fetch(this.baseURL + '/business/' + id, {
                    method: 'PUT',
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type':'application/json'
                    },
                    body: JSON.stringify({subscription_months:number_of_months,subscription_time:subs_time})
                }).then( rsp =>{
                    return rsp.json()
                }).then( () => {
                    // notify user
                    alert('Stripe Payment succeeded.\n\nThank You for your order!')
                    // activate pay button
                    this.entityFlag = true
                    // update in $store current business
                    this.$store.commit('setSuspendedAccount',false)
                    let currentbusiness = this.$store.getters.getCurrentBusiness
                    currentbusiness.subscription_months = number_of_months
                    currentbusiness.subscription_time = subs_time
                    this.$store.commit('setCurrentBusiness',currentbusiness)
                    // go to features pages
                    this.$router.push('/features')
                }).catch(err => {
                    //console.log('Error when delete redeem ...'+err.message)
                    this.error_message = err.message
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    body {
        height: 150vh;
    }
     .required:after {
         content:" *";
         color: lightpink;
     }
    // stripe elements
    .stripe-container {
        padding-top: 10px;
        max-width: 700px;
        margin-top: 20px;
        margin-left:20%;
        background-color: royalblue;
        color: white;
        border-radius: 10px;
        opacity: 0.8;
    }
    input,
    .StripeElement {
        box-sizing: border-box;
        height: auto;
        border: 1px solid transparent;
        border-radius: 4px;
        background-color: white;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
        padding: 8px 8px;
    }
    input:focus
    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 black;
        color: #000;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }
    // page elements
    .row {
        display: -ms-flexbox; /* IE10 */
        display: flex;
        -ms-flex-wrap: wrap; /* IE10 */
        flex-wrap: wrap;
        margin: 0 -16px;
    }

    .col-25 {
        -ms-flex: 25%; /* IE10 */
        flex: 25%;
    }

    .col-50 {
        -ms-flex: 50%; /* IE10 */
        flex: 50%;
    }

    .col-75 {
        -ms-flex: 75%; /* IE10 */
        flex: 75%;
    }

    .col-25,
    .col-50,
    .col-75 {
        padding: 0 16px;
    }
    label {
        margin-bottom: 10px;
        //display: block;
        font-size: 13px;
        text-align: left;
        clear: both;
        float:left;
        font-weight: bold;
    }
    input[type=text] {
        width: 80%;
        height: 30px;
        margin-bottom: 25px;
        padding: 12px;
        border: 1px solid #ccc;
        border-radius: 10px;
        background-color: white;
    }
    input[type=email] {
        width: 40%;
        height: 30px;
        margin-bottom: 25px;
        padding: 12px;
        border: 1px solid #ccc;
        border-radius: 10px;
        background-color: white;
    }
    input[type=business] {
        width: 50%;
        height: 20px;
        margin-bottom: 25px;
        padding: 12px;
        border: 1px solid #ccc;
        border-radius: 10px;
        background-color: white;
    }
    input[type=number] {
        width: 5em;
        height: 20px;
        margin-bottom: 25px;
        padding: 12px;
        border: 1px solid #ccc;
        border-radius: 10px;
        background-color: white;
        margin-left: 5px;
    }

    .icon-container {
        padding: 7px 0;
    }
    .btn {
        background-color: dodgerblue;
        color: white;
        padding: 12px;
        margin: 10px 0;
        border: none;
        width: 30%;
        border-radius: 3px;
        cursor: pointer;
        font-size: 15px;
    }
    .btn:hover {
        background-color: royalblue;
    }
    .btn:disabled {
        background-color: #aaaaaa;
    }

    .btncancel {
        background-color: darkred;
        color: white;
        padding: 12px;
        margin: 10px 0;
        border: none;
        width: 30%;
        border-radius: 3px;
        cursor: pointer;
        font-size: 15px;
    }
    .btncancel:hover {
        background-color: crimson;
    }
    .btnredeem {
        background-color: lightpink;
        color: white;
        padding: 12px;
        margin: 10px 0;
        border: none;
        width: 30%;
        border-radius: 3px;
        cursor: pointer;
        font-size: 15px;
    }
    .btnredeem:hover {
        background-color: lightcoral;
    }
    a {
        color: #ffffff;
    }

    hr {
        border: 1px solid lightgrey;
    }

    .price {
        font-weight: bold;
        color: white;
    }
    .bankmsg {
        //font-weight: bold;
        font-style: italic;
        font-size: 10px;
    }
    .tokenvalue {
        font-weight: bold;
        font-family: American Typewriter;
        font-size: 10px;
        color: white;
    }
    .publish {
        color: darkorange;
    }
    .publish:hover {
        background-color: orangered;
        color: white;
        opacity: 0.9;
    }
    /* Mark input boxes that gets an error on validation: */
    input.invalid {
        background-color: #ffdddd;
    }
    .valability {
        font-size: 14px;
        font-weight: bold;
        color: darkblue;
        background-color: lightgreen;
        padding: 5px 5px
    }
    /* Responsive layout - when the screen is less than 600px wide,
       make the two columns stack on top of each other instead of next to each other
    */
    @media screen and (max-width: 600px) {
        .stripe-container {
            margin-left: 0;
        }
        .row {
            flex-direction: column-reverse;
        }
        .col-25 {
            margin-bottom: 20px;
        }
        button {
            font-size: 10px;
        }
        input[type=text],input[type=email],input[type=business] {
            height: 0px;
            font-size: 12px;
            width: 100%;
        }
        .icon-container {
            font-size: 10px;
        }
        .bankmsg {
            font-size: 8px;
        }
        .tokenvalue {
            font-size: 15px;
        }
        .btncancel {
            font-size: 10px;
        }
        .btn {
            font-size: 10px;
        }
        .btnredeem {
            font-size: 10px;
        }
    }
</style>